import { Button, Grid, Typography } from "@mui/material";
import { Formik } from "formik";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { endPrep } from "../../../api/project";
import { RoleComponentGuard } from "../../Reuseables/Guards/RoleComponentGuard";
import AreYouSureDialog from "../../Reuseables/Dialogs/AreYouSureDialog";
import ReviewSubmitTable from "../../Reuseables/Tables/ReviewSubmitTable";
import { useApplicationContext } from "../../ContextProviders/ApplicationContext";
import { Role } from "../../../types/enums";
import { Project } from "../../../types/project";
import { useOrganizationContext } from "../../ContextProviders/OrganizationContext";

type ReviewViewProps = {
  setView: (n: number) => void;
  project: Project;
};

export default function ReviewView({ setView, project }: ReviewViewProps) {
  const { t } = useTranslation();
  const [areYouSure, setAreYouSure] = useState(false);
  const { showSnackbar } = useApplicationContext();
  const { updateProject } = useOrganizationContext();
  const _onSubmit = async (values: Project) => {
    try {
      let project = await endPrep(values);

      updateProject(project);
    } catch (error: unknown) {
      if (error instanceof Error) {
        showSnackbar(error.message, "error");
      } else {
        showSnackbar("Unknown error", "error");
      }
    }
  };
  const handleCloseAreYouSure = () => {
    setAreYouSure(false);
  };
  const handleOpenAreYouSure = () => {
    setAreYouSure(true);
  };
  return (
    <Formik
      key={project.projectCode}
      initialValues={project}
      onSubmit={_onSubmit}
    >
      {(props) => (
        <>
          <Grid
            container
            mt={2}
            minHeight={"65vh"}
            sx={{
              flexDirection: {
                xs: "column",
                sm: "column",
                md: "column",
                lg: "row",
              },
            }}
          >
            <RoleComponentGuard roles={[Role.PrecureAdmin, Role.SolutionOwner,Role.Partner]}>
              <ReviewSubmitTable values={project} />
            </RoleComponentGuard>
          </Grid>
          <Grid container justifyContent={"space-around"}>
            <Button variant="contained" onClick={() => setView(1)}>
              {t("buttons.back")}
            </Button>
            <RoleComponentGuard roles={[Role.PrecureAdmin, Role.SolutionOwner,Role.Partner]}>
              <Button variant="contained" onClick={handleOpenAreYouSure}>
                {t("buttons.submit")}
              </Button>
            </RoleComponentGuard>
          </Grid>
          <AreYouSureDialog
            isDialogOpen={areYouSure}
            handleClose={handleCloseAreYouSure}
            title={t("dialogs.areYouSureHeader")}
            content={<Typography>{t("dialogs.areYouSureText2")}</Typography>}
            isSubmitting={props.isSubmitting}
            onSubmit={async () => {
              let errors = await props.validateForm();
              if (Object.keys(errors).length !== 0) {
                handleCloseAreYouSure();
              } else {
                props.submitForm();
              }
            }}
          />
        </>
      )}
    </Formik>
  );
}
